import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import NutritionVitaminDCombined from "./index";

const NutritionVitaminDWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={NutritionVitaminDCombined}
    keyControlsId="nutrition-vitamin-d-key"
    {...props}
  />
);

export default NutritionVitaminDWithToggleKey;
